import React, { useState } from 'react';
import './ContactForm.css';
import { motion } from 'framer-motion';
import {
  staggerContainer,
  item,
  fadeInUp,
  slideInLeft,
  slideInRight,
  scaleIn,
} from '../../styles/animations';

const WEB3FORMS_ACCESS_KEY = '4e736846-0104-454a-9265-0855f646d04b'; // Replace with your Web3Forms access key

const ContactForm = () => {
  const [status, setStatus] = useState({ type: '', message: '' });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', message: '' });

    const data = {
      access_key: WEB3FORMS_ACCESS_KEY,
      ...formData,
      subject: 'New Contact Form Submission',
      from_name: formData.name,
    };

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      const result = await response.json();

      if (result.success) {
        setStatus({
          type: 'success',
          message: 'Thank you! Your message has been sent successfully.',
        });
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus({
          type: 'error',
          message: result.message || 'Something went wrong. Please try again.',
        });
      }
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'Network error. Please try again later.',
      });
    }
  };

  return (
    <section className="contact-section">
      {/* Header Section */}
      <div className="contact-header">
        <motion.h1
          className="contact-heading"
          variants={fadeInUp}
          initial="hidden"
          animate="visible"
        >
          Contact <span>Us</span>
        </motion.h1>
        <p className="contact-subtext">
          We’d love to hear from you! Reach out for inquiries, support, or collaboration.
        </p>
      </div>

      {/* Main Contact Container */}
      <div className="container">
        <motion.div
          className="contact-content"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Contact Info Section */}
          <motion.div className="contact-info" variants={slideInLeft}>
            <h3 className="contact-title">Get in Touch</h3>
            <div className="contact-item">
              <ul className="contact-list">
                <li>
                  <span className="font-bold">📞 Phone:</span> +91 9133 456 915
                </li>
                <li>
                  <span className="font-bold">✉️ Email:</span>{' '}
                  <a href="mailto:hr@lyrostech.com" className="contact-link">
                    hr@lyrostech.com
                  </a>
                </li>
              </ul>
            </div>

            <div className="contact-details">
              <h4 className="office-heading">Office Locations</h4>
              <div className="office-locations">
                <div>
                  <h5>USA:</h5>
                  <p>8520, Cotter St Lewis Center, OH 43035, United States</p>
                </div>
                <div>
                  <h5>Hyderabad:</h5>
                  <p>
                    Q-2, A1, 7th Floor, Cyber Towers, Hitech City, Hyderabad,
                    Telangana, India - 500081
                  </p>
                </div>
                <div>
                  <h5>Visakhapatnam:</h5>
                  <p>
                    ā hub: 3rd Floor, AUIC - North Campus, Andhra University,
                    Visakhapatnam, Andhra Pradesh, India – 530003 
                  </p>
                </div>
                <div>
                  <h5>Bangalore:</h5>
                  <p>
                    Tapaswiji info park, TechZone, 184/185, Whitefield,
                    Bengaluru, Karnataka, India - 560066
                  </p>
                </div>
              </div>
            </div>

            {/* Embedded Google Map */}
         
          </motion.div>
          

          {/* Contact Form Section */}
          <motion.div className="contact-form" variants={slideInRight}>
            {status.type && (
              <motion.div
                className={`form-status ${status.type}`}
                variants={scaleIn}
                initial="hidden"
                animate="visible"
              >
                {status.message}
              </motion.div>
            )}
            <motion.form
              onSubmit={handleSubmit}
              autoComplete="off"
              variants={staggerContainer}
              initial="hidden"
              animate="visible"
            >
              <motion.h3
                className="form-heading"
                variants={fadeInUp}
              >
                Send Us a Message
              </motion.h3>
              <motion.div className="form-group" variants={item}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your Name"
                />
              </motion.div>
              <motion.div className="form-group" variants={item}>
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Your Email"
                />
              </motion.div>
              <motion.div className="form-group" variants={item}>
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Your Message"
                />
              </motion.div>
              <motion.button
                type="submit"
                className="submit-btn"
                variants={fadeInUp}
              >
                Send Message
              </motion.button>
            </motion.form>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactForm;
